export const defaultValues = () => {
  return {
    exhibitionValues: {
      idiomas: [],
      prioritaria: false,
      exibeDesconto: false,
      promocao: false,
      urlImagemPromocional: ''
    },

    pricingValues: {
      tipoCoeficiente: 0,
      coeficiente: 100,
      coeficienteDiasSemana: []
    },

    rulesValues: {
      devices: [],
      lastMinute: null,
      lastMinuteDescricao: null,
      minimoAdultos: null,
      minimoCriancas: null,
      maximoAdultos: null,
      maximoCriancas: null,
      promocodes: [],
      tarifasCorporativas: [],
      percentualOcupacaoMinimo: null,
      percentualOcupacaoMaximo: null
    },

    differentialsValues: {
      periodosHospedagem: [],
      dataPernoiteObrigatorio: '',
      dataInicioReserva: '',
      dataFimReserva: '',
      horaInicioReserva: '',
      horaFimReserva: '',
      minimoNoitesDe: null,
      minimoNoitesAte: null,
      coeficienteCheckin: 100,
      coeficienteCheckout: 100,
      checkinSegunda: false,
      checkinTerca: false,
      checkinQuarta: false,
      checkinQuinta: false,
      checkinSexta: false,
      checkinSabado: false,
      checkinDomingo: false,
      antecedenciaDe: null,
      antecedenciaAte: null,
      diasToleranciaCheckin: null,
      diasToleranciaCheckout: null
    },

    paymentValues: {
      meiosPagamento: [],
      habilitarPagamentoPix: false
    },

    hoteis: [],

    gruposCrm: []
  }
}

export const hotelRateValues = () => {
  return {
    settings: {
      codigo: 0,
      nome: '',
      tipoCoeficiente: 0,
      codigoPMS: null,
      quartos: null
    },

    pricing: {
      codigoTarifaBase: 0,
      tipoFlutuacao: 0,
      pensoes: [],
      precosQuartos: [],
      tipoCoeficiente: 0,
      diferenciaisQuartos: [],
      diferenciaisPax: [],
      quartos: null
    },

    periods: {
      periodosBlackout: [],
      dataInicioPeriodoDestaque: null,
      dataFimPeriodoDestaque: null,
      pacoteFechado: false
    },

    allotment: {
      allotmentQuartos: [],
      quartos: []
    }
  }
}
